// extracted by mini-css-extract-plugin
export var brand = "_1n-8";
export var compact = "_1n-5";
export var extraSmall = "_1n-6";
export var icon = "_1n-0";
export var large = "_1n-3";
export var light = "_1n-1";
export var medium = "_1n-4";
export var outline = "_1n-a";
export var primaryDark = "_1n-9";
export var primaryLight = "_1n-7";
export var primaryModern = "_1n-b";
export var success = "_1n-2";